import { AppContext, BookingData } from "../../../AppDataProvider/AppDataProvider";
import { boxShadows, corners, dateFormats, padding, typography } from "../../../common/styles";
import React, { useContext, useEffect } from "react";
import { requireBookingDataFields, today } from "../../../utils";
import { add } from "date-fns";
import { Link } from "../../../common/components";
import { Mixpanel } from "../../../mixpanel";
import { PartRequired } from "@src/App/utils/types";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import CustomerTranslations from "../../../utils/CustomerTranslations";
type NoAvailabilityStepBookingData = PartRequired<BookingData, "organisation">;
export type NoAvailabilityProps = {
  hasSearchedFurtherAhead: boolean;
  monthOffset: number;
  onSearchMore: () => void;
};
const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  background: ${({
  theme
}) => theme.brand.cssVars["--d-card"]};
  color: ${({
  theme
}) => theme.brand.cssVars["--d-text"]};
  ${typography.bodyBold}
  ${padding.l}
  ${corners.l}
  ${boxShadows.subtleShadow}
`;
export function NoAvailability({
  hasSearchedFurtherAhead,
  monthOffset,
  onSearchMore
}: NoAvailabilityProps) {
  const {
    i18n,
    t
  } = useTranslation();
  const {
    translateEntity
  } = CustomerTranslations.useCustomerTranslation();
  const currentMonth = add(today, {
    months: monthOffset
  });
  const {
    appData
  } = useContext(AppContext);
  const {
    bookingData
  } = appData;
  requireBookingDataFields<NoAvailabilityStepBookingData>(bookingData, ["organisation"]);
  const {
    organisation
  } = bookingData;
  useEffect(() => {
    Mixpanel.track({
      name: "No availability",
      props: {
        searchType: hasSearchedFurtherAhead ? "SEARCH_FURTHER_AHEAD" : "INITIAL"
      }
    });
  }, [hasSearchedFurtherAhead]);
  const translatedAccount = translateEntity({
    document: organisation,
    type: "account"
  });
  const message = translatedAccount.customNoAvailabilityText ? translatedAccount.customNoAvailabilityText : monthOffset === 0 ? t("noAvailableTimesFoundMonth", {
    currentMonthDate: currentMonth.toLocaleString(i18n.language, dateFormats.monthAndYear)
  }) : t("noAvailableTimesFoundOffset", {
    count: monthOffset
  });
  return <Container data-sentry-element="Container" data-sentry-component="NoAvailability" data-sentry-source-file="NoAvailability.tsx">
      {message}
      <Link tabIndex={0} onClick={onSearchMore} onKeyPress={event => {
      if (event.key === "Enter") {
        onSearchMore();
      }
    }} data-sentry-element="Link" data-sentry-source-file="NoAvailability.tsx">
        {t("searchFurtherAheadLink")}
      </Link>
    </Container>;
}
export default NoAvailability;